import { CustomProperty, Containers, Environment } from "./feature-toggle.types";
import { Observable } from "rxjs";
import { RoxSetupOptions } from "rox-browser";

export class IpcFeatureToggleConfiguration {
    options: RoxSetupOptions;
    key: string;
    environment: Environment;
    customProperties?: Map<string, CustomProperty | Observable<CustomProperty>>;
    containers: Containers;
}
